import { render } from "./FactureForPrint.vue?vue&type=template&id=0c63bd46"
import script from "./FactureForPrint.vue?vue&type=script&lang=js"
export * from "./FactureForPrint.vue?vue&type=script&lang=js"

import "./FactureForPrint.vue?vue&type=style&index=0&id=0c63bd46&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__